import { useApi } from '@hooks/useApi';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { queryKeys } from '@utils/consts';
import { BenchUser } from '@root/globalTypes';

export function useDelete({ id, callback }: { id: string; callback: () => Promise<void> }) {
  const { query } = useApi();
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationFn: (): Promise<BenchUser> => {
      return query({
        path: `v1/staff/bench_users/${id}`,
        opt: {
          method: 'DELETE',
        },
      });
    },
    onSuccess: async () => {
      await queryClient.refetchQueries({ queryKey: queryKeys.benchUsers });
      await callback();
    },
  });

  return {
    mutate,
    isPending,
  };
}
